import type { FallbackRender } from '@sentry/react';

const ErrorFallback: FallbackRender = ({ resetError }) => (
    <div className="min-h-screen bg-gray-100 flex items-center justify-center p-6">
        <div className="bg-white rounded-xl shadow-sm border border-gray-100 p-8 max-w-md w-full">
            <h1 className="text-xl font-bold text-gray-800 mb-2">Something went wrong</h1>
            <p className="text-sm text-gray-600 mb-6">
                An unexpected error occurred. Our team has been notified. Please reload the page to
                continue.
            </p>
            <button
                type="button"
                onClick={resetError}
                className="bg-black text-white font-semibold px-6 py-2 rounded-xl shadow hover:bg-gray-900 transition-colors"
            >
                Reload page
            </button>
        </div>
    </div>
);

export { ErrorFallback };
